export const getSelectedFile = (state) => state?.selectedFileSlice.file;
